import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { User } from '../_models/user';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseUrl = environment.apiUrl + 'auth/';
  jwtHelper = new JwtHelperService();
  decodedToken: any;
  currentUser: User;

  adminUser: User;
  clientUser: User;
  serviceManUser: User;
  tollDistributerUser: User;

  adminDecodedToken: any;
  clientDecodedToken: any;
  serviceManDecodedToken: any;
  tollDistributerDecodedToken: any;

  constructor(
    private http: HttpClient, 
    private router: Router, 
    private notify: NotificationService
  ) { }

  loginByClientId(clientId: number,adminUserName:string,adminId:number,ipAddress:string) {
    return this.http.get<any>(this.baseUrl + `login/clients/${clientId}`,
    {
      params: {
          aditionalParams: JSON.stringify({ adminUserName, adminId, ipAddress })
      }
  }

    ).pipe(
      map(response => {
        if (response?.token === undefined || response?.token === null) {
          return;
        }

        this.initLocalStorage({ user: response.user, token: response.token });
        this.initDecodedTokenByRole(response.token);

        const routePath = this.getUrlByRole(response.user.role),
              urlTree = this.router.createUrlTree([routePath]),
              url = this.router.serializeUrl(urlTree);

        window.open(url, '_blank');

        this.notify.success('Uspešno logovanje');
      })
    );
  }

  initUser(user): User {
    if (user.role === 0) {
      this.adminUser = user;
      return this.adminUser;
    }

    if (user.role === 1) {
      this.clientUser = user;
      return this.clientUser;
    }

    if (user.role === 2) {
      this.serviceManUser = user;
      return this.serviceManUser;
    }

    if (user.role === 3) {
      this.tollDistributerUser = user;
      return this.tollDistributerUser;
    }
  }

  getUserRoleAlias({ role }: { role: number }): string {
    const userRoleAlias = {
      0: 'admin',
      1: 'client',
      2: 'serviceMan',
      3: 'srbToll/distributer/clients'
    };
    return userRoleAlias[role];
  }

  initDecodedTokenByRole({ role, token }): void {
    if (role === 0) {
      this.adminDecodedToken = this.jwtHelper.decodeToken(token);
    }

    if (role === 1) {
      this.clientDecodedToken = this.jwtHelper.decodeToken(token);
    }

    if (role === 2) {
      this.serviceManDecodedToken = this.jwtHelper.decodeToken(token);
    }

    if (role === 3) {
      this.tollDistributerDecodedToken = this.jwtHelper.decodeToken(token);
    }
  }

  initLocalStorage({ user, token }): void {
    const roleAlias = this.getUserRoleAlias({ role: user.role }),
          userStr = JSON.stringify(user);
    localStorage.setItem(`${roleAlias}-token`, token);
    localStorage.setItem(`${roleAlias}-user`, userStr);
    localStorage.setItem(`${roleAlias}-map`, 'false');
  }

  getUrlByRole(role: number): string {
    const url = {
      0: '/companies',
      1: '/vehicles',
      2: '/freeModems',
      3: `/srbToll/distributer/clients`
    };
    return url[role];
  }

  navigateUrlByRole(role: number): void {
    this.router.navigateByUrl(this.getUrlByRole(role));
    this.notify.success('Uspešno logovanje');
  }

  loginSystem(input,IpAddress:string) {
    input.IpAddress = IpAddress;
    console.log(input);
   
    return this.http.post(this.baseUrl + `login`, input)
      .pipe(
        map((response: any) => {
          const user = this.initUser(response.user);

          this.initLocalStorage({ user, token: response.token});
          this.initDecodedTokenByRole({ role: user.role, token: response.token });
          
          this.navigateUrlByRole(user.role);

          return user;
        })
      )
  }

  getAdminUser(): User {
    const userRoleAlias = this.getUserRoleAlias({ role: 0 }),
          userStr = localStorage.getItem(`${userRoleAlias}-user`);
    this.adminUser = JSON.parse(userStr);
    return this.adminUser;
  }

  getClientUser(): User {
    const userRoleAlias = this.getUserRoleAlias({ role: 1 }),
          userStr = localStorage.getItem(`${userRoleAlias}-user`);
    this.clientUser = JSON.parse(userStr);
    return this.clientUser;
  }

  getServiceManUser(): User {
    const userRoleAlias = this.getUserRoleAlias({ role: 2 }),
          userStr = localStorage.getItem(`${userRoleAlias}-user`);
    this.serviceManUser = JSON.parse(userStr);
    return this.serviceManUser;
  }

  getTollDistributerUser(): User {
    const userRoleAlias = this.getUserRoleAlias({ role: 3 }),
    userStr = localStorage.getItem(`${userRoleAlias}-user`);
    this.serviceManUser = JSON.parse(userStr);
    return this.serviceManUser;
  }

  login(model: any) {
    return this.http.post(this.baseUrl + 'login', model).pipe(
      map((response: any) => {
        const user = response;
        if (user) {
          localStorage.setItem('token', user.token);
          localStorage.setItem('user', JSON.stringify(user.user));
          localStorage.setItem('map', 'false');

          this.decodedToken = this.jwtHelper.decodeToken(user.token);
          this.currentUser = user.user;
        }
      })
    );
  }

  isLoggedInAdmin(): boolean {
    const roleAlias = this.getUserRoleAlias({ role: 0 }),
          token = localStorage.getItem(`${roleAlias}-token`);
    return !this.jwtHelper.isTokenExpired(token);
  }

  isLoggedInClient(): boolean {
    const roleAlias = this.getUserRoleAlias({ role: 1 }),
          token = localStorage.getItem(`${roleAlias}-token`);
    return !this.jwtHelper.isTokenExpired(token);
  }

  isLoggedInServiceMan(): boolean {
    const roleAlias = this.getUserRoleAlias({ role: 2 }),
          token = localStorage.getItem(`${roleAlias}-token`);
    return !this.jwtHelper.isTokenExpired(token);
  }

  isLoggedInTollDistributer(): boolean {
    const roleAlias = this.getUserRoleAlias({ role: 3 }),
          token = localStorage.getItem(`${roleAlias}-token`);
    return !this.jwtHelper.isTokenExpired(token);
  }

  register(user: User) {
    return this.http.post(this.baseUrl + 'register', user);
  }

  getCurrentUser() {
    const strUser = localStorage.getItem('user');
    this.currentUser = JSON.parse(strUser);
    return this.currentUser;
  }

  loggedIn() {
    const token = localStorage.getItem('token');
    return !this.jwtHelper.isTokenExpired(token);
  }

  sendRequestForChangePassword(model: any) {
    return this.http.post(this.baseUrl + 'forgotPassword', model);
  }

  checkToken(model: any) {
    return this.http.post(this.baseUrl + 'checkToken', model);
  }

  changePassword(model: any) {
    return this.http.post(this.baseUrl + 'changePass', model);
  }

  getCurrentClient(id: number) {
    return this.http.get(this.baseUrl + 'getClient/' + id);
  }
  getIPAddress()
  {
    return  this.http.get("https://api.ipify.org/?format=json")    
  }
}
